"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderIncomesPath = void 0;
function getProviderIncomesPath(country, type) {
    return `/parametros/${country}/providerIncomes/historicalIncomes/${type}`;
}
exports.getProviderIncomesPath = getProviderIncomesPath;
